export default "__VITE_ASSET__C5WAk4hc__"